import './footerMobile.scss';

import React, { FunctionComponent, useState } from 'react';


import { useTranslation } from 'react-i18next';
import { LocalizedLink } from '../../primitives';
import { ArrowRight } from '../buttons/ArrowRight';

export const FooterMobile: FunctionComponent = () => {
    const { t } = useTranslation('mainLayout');

    const [productOpen, setProductOpen] = useState(false);
    const [partOpen, setPartOpen] = useState(false);
    const [supportOpen, setSupportOpen] = useState(false);

    return (
        <div className='mobile-footer-link'>
            <div className='sidenavMenu'>
                <div>
                    <p
                        className='pointer'
                        style={
                            productOpen
                                ? { marginBottom: '1rem' }
                                : { marginBottom: 0 }
                        }
                        onClick={() => setProductOpen(!productOpen)}
                    >
                        {t('products')}
                        {!productOpen && (
                            <span>
                                <ArrowRight />
                            </span>
                        )}
                    </p>
                    {productOpen && (
                        <div className='productsMenu'>
                            <LocalizedLink to='/wood-stoves/'>
                                <ArrowRight intlKey='stoves' />
                            </LocalizedLink>
                            <LocalizedLink to='/wood-inserts/'>
                                <ArrowRight intlKey='inserts' />
                            </LocalizedLink>
                        </div>
                    )}
                </div>

                <div>
                    <p
                        className='pointer'
                        style={
                            partOpen
                                ? { marginBottom: '1rem' }
                                : { marginBottom: 0 }
                        }
                        onClick={() => setPartOpen(!partOpen)}
                    >
                        {t('parts')}
                        {!partOpen && (
                            <span>
                                <ArrowRight />
                            </span>
                        )}
                    </p>
                    {partOpen && (
                        <div className='productsMenu'>
                            <LocalizedLink to='/archives/'>
                                <ArrowRight intlKey='parts-only' />
                            </LocalizedLink>
                            <LocalizedLink to='/accessories/'>
                                <ArrowRight intlKey='accessories' />
                            </LocalizedLink>
                            <LocalizedLink to='/venting/'>
                                <ArrowRight intlKey='venting' />
                            </LocalizedLink>
                        </div>
                    )}
                </div>

                <div>
                    <p
                        className='pointer'
                        style={
                            supportOpen
                                ? { marginBottom: '1rem' }
                                : { marginBottom: 0 }
                        }
                        onClick={() => setSupportOpen(!supportOpen)}
                    >
                        {t('support')}
                        {!supportOpen && (
                            <span>
                                <ArrowRight />
                            </span>
                        )}
                    </p>
                    {supportOpen && (
                        <div className='productsMenu'>
                            <LocalizedLink to='/articles/'>
                                <ArrowRight intlKey='articles' />
                            </LocalizedLink>
                            <LocalizedLink to='/videos/'>
                                <ArrowRight intlKey='videos' />
                            </LocalizedLink>
                            <LocalizedLink to='/warranty/'>
                                <ArrowRight intlKey='warranty' />
                            </LocalizedLink>
                            <LocalizedLink to='/archives/'>
                                <ArrowRight intlKey='manuals-only' />
                            </LocalizedLink>
                            <LocalizedLink to='/installer/'>
                                <ArrowRight intlKey='findinstaller' />
                            </LocalizedLink>
                            <LocalizedLink to='/about/'>
                                <ArrowRight intlKey='about' />
                            </LocalizedLink>
                            <LocalizedLink to='/government-incentives/'>
                                <ArrowRight intlKey='gov-incentives' />
                            </LocalizedLink>
                            <LocalizedLink to='/contact-us/'>
                                <ArrowRight intlKey='contact' />
                            </LocalizedLink>
                            <LocalizedLink to='/order-status/'>
                                <ArrowRight intlKey='order-status-title' />
                            </LocalizedLink>
                        </div>
                    )}
                </div>

                <LocalizedLink to='/promotions/'>
                    <div>
                        {t('promotions')}
                        <span>
                            <ArrowRight />
                        </span>
                    </div>
                </LocalizedLink>

                <LocalizedLink className='contact-us' to='/contact-us/'>
                    <span>{t('contact-us-title')}</span>
                </LocalizedLink>
            </div>
        </div>
    );
};
